import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import locationIcon from '../../../../assets/icons/location-outlined.svg'
import phoneIcon from '../../../../assets/icons/phone-outlined.svg'
import clockIcon from '../../../../assets/icons/clock-outlined.svg'

import Card from '../Card'
import Openings from '../Openings'

class InfoCard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { classes, merchant } = this.props
    if (!merchant) return null
    const { name, address, contact } = merchant
    const tags = []

    if (merchant.setting.directoryTags) {
      merchant.setting.directoryTags.split(',').map(o => {
        tags.push(o.trim())
      })
    }

    return (
      <Card>
        <div className={classes.spacing}>
          <p className={classes.title}>{name}</p>
          <div className={classes.tags}>
            {tags}
          </div>
        </div>
        <div className={classes.spacing}>
          <div className={classes.info}>
            <div className={classes.icon}>
              <img src={locationIcon} alt='location_icon' />
            </div>
            <div className={classes.gridContainer}>
              <a
                className={classes.gridItemFullwidth}
                href={merchant.setting.mapLink || `https://www.google.com/maps?q=${address}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {address || '--'}
              </a>
            </div>
          </div>
          {/* <div className={classes.info}>
            <div className={classes.icon}>
              <img src={phoneIcon} alt='phone_icon' />
            </div>
            <div className={classes.gridContainer}>
              <a
                className={classes.gridItemFullwidth}
                href={`tel:${contact}`}>
                {contact || '--'}
              </a>
            </div>
          </div> */}
          <div className={classes.info}>
            <div className={classes.icon}>
              <img src={clockIcon} alt='clock_icon' />
            </div>
            <Openings />
          </div>
        </div>
      </Card>
    )
  }
}

const styles = {
  spacing: {
    padding: 4,
  },
  title: {
    padding: 4,
    fontSize: 30,
    fontWeight: 'bold',
  },
  tags: {
    fontSize: 15,
    lineHeight: '24px',
    fontWeight: 300,
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
    padding: 4,
  },
  info: {
    padding: 4,
    display: 'flex',
    '& p': {
      fontSize: 15,
      fontWeight: 300,
      lineHeight: '21px', // the height of the icon.
    },
    '& a': {
      color: '#ffffff',
      fontSize: 15,
      fontWeight: 'bold',
      lineHeight: '21px', // the height of the icon.
    },
  },
  icon: {
    height: 21,
    width: 21,
    display: 'grid',
    placeItems: 'center',
    marginRight: 8,
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridGap: '4px',
    width: '100%',
    wordBreak: 'break-all',
    '& > p': {
      whiteSpace: 'pre-line',
    },
  },
  gridItemFullwidth: {
    gridColumn: '1 / span 3',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(InfoCard)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Card/InfoCard.jsx